/**
 * "Boire et noter", formerly "Réduire le stock" (owner requests, 2026-10-06 and 2026-10-09): the
 * bottle drunk is found by a free-text search on the Domaine and the Parcelle, among the wines
 * with bottles left, and rated with up and down arrows by half points, from 5 (the default) down to 1, then "no rating".
 */
import { wineStock, type Wine } from './cellar';
import { normaliseIdentityField } from './identity';

const byName = (a: Wine, b: Wine) =>
  a.domaine.localeCompare(b.domaine, 'fr', { sensitivity: 'base' }) || a.annee - b.annee;

/** The wines with bottles left whose Domaine or Parcelle holds every word typed, A to Z. */
export function winesToDrink(wines: readonly Wine[], query: string): Wine[] {
  const words = normaliseIdentityField(query)
    .split(' ')
    .filter((word) => word !== '');
  return wines
    .filter((wine) => wineStock(wine) > 0)
    .filter((wine) => {
      const text = normaliseIdentityField(`${wine.domaine} ${wine.parcelle ?? ''}`);
      return words.every((word) => text.includes(word));
    })
    .sort(byName);
}

/** The rating one step up or down: half points from 1 to 5; below 1 is "no rating" (undefined). */
export function stepRating(
  rating: number | undefined,
  direction: 'up' | 'down',
): number | undefined {
  if (direction === 'up') return rating === undefined ? 1 : Math.min(5, rating + 0.5);
  if (rating === undefined || rating <= 1) return undefined;
  return rating - 0.5;
}
